import brandingColors from '../colors/colors.js';
import { MOBILE_MENU_VARIANT, TAB_VARIANT, LANG_VARIANT, SIGN_IN_VARIANT } from '../components/SideNav/constants.js';
import { TAB_ALIGNMENT } from '../components/UtilityHeader/constants.js';
import { GRID_BREAKPOINTS_CONNECTED } from '../spacing/index.js';
import { rem } from '../utils/functions.js';

var globalTheme = {
  name: 'globalTheme',
  colorPalette: {
    primaryColors: {
      main: {
        shade_light_4: brandingColors.light_4_green,
        shade_light_3: brandingColors.light_3_green,
        shade_light_2: brandingColors.light_2_green,
        shade_light_1: brandingColors.light_1_green,
        shade_default: brandingColors.m_green,
        shade_link: brandingColors.m_green,
        shade_dark_1: brandingColors.dark_1_green,
        shade_dark_2: brandingColors.dark_2_green,
        shade_dark_3: brandingColors.dark_3_green
      },
      alternate: {
        shade_light_4: brandingColors.light_4_blue,
        shade_light_3: brandingColors.light_3_blue,
        shade_light_2: brandingColors.light_2_blue,
        shade_light_1: brandingColors.light_1_blue,
        shade_default: brandingColors.blue,
        shade_dark_1: brandingColors.dark_1_blue,
        shade_dark_2: brandingColors.dark_2_blue,
        shade_dark_3: brandingColors.dark_3_blue
      }
    },
    neutralColors: {
      dark: {
        shade_light_4: brandingColors.light_4_dark_navy,
        shade_light_3: brandingColors.light_3_dark_navy,
        shade_light_2: brandingColors.light_2_dark_navy,
        shade_light_1: brandingColors.light_1_dark_navy,
        shade_default: brandingColors.dark_navy,
        shade_dark_1: brandingColors.super_dark_navy
      },
      light: {
        shade_white: brandingColors.white,
        shade_light_2: brandingColors.light_2_grey,
        shade_light_1: brandingColors.light_1_grey,
        shade_default: brandingColors.light_grey,
        shade_dark_1: brandingColors.dark_1_light_grey,
        shade_dark_2: brandingColors.dark_2_light_grey,
        shade_dark_3: brandingColors.dark_3_light_grey
      }
    },
    accentColor: {
      shade_light_4: brandingColors.light_4_coral,
      shade_light_3: brandingColors.light_3_coral,
      shade_light_2: brandingColors.light_2_coral,
      shade_light_1: brandingColors.light_1_coral,
      shade_default: brandingColors.coral,
      shade_dark_1: brandingColors.dark_1_coral,
      shade_dark_2: brandingColors.dark_2_coral,
      shade_dark_3: brandingColors.dark_3_coral
    },
    secondaryColors: {
      one: {
        shade_light_4: brandingColors.light_4_violet,
        shade_light_3: brandingColors.light_3_violet,
        shade_light_2: brandingColors.light_2_violet,
        shade_light_1: brandingColors.light_1_violet,
        shade_default: brandingColors.violet,
        shade_dark_1: brandingColors.dark_1_violet,
        shade_dark_2: brandingColors.dark_2_violet,
        shade_dark_3: brandingColors.dark_3_violet
      },
      two: {
        shade_light_4: brandingColors.light_4_gold,
        shade_light_3: brandingColors.light_3_gold,
        shade_light_2: brandingColors.light_2_gold,
        shade_light_1: brandingColors.light_1_gold,
        shade_default: brandingColors.gold,
        shade_dark_1: brandingColors.dark_1_gold,
        shade_dark_2: brandingColors.dark_2_gold,
        shade_dark_3: brandingColors.dark_3_gold
      },
      three: {
        shade_light_4: brandingColors.light_4_turquoise,
        shade_light_3: brandingColors.light_3_turquoise,
        shade_light_2: brandingColors.light_2_turquoise,
        shade_light_1: brandingColors.light_1_turquoise,
        shade_default: brandingColors.turquoise,
        shade_dark_1: brandingColors.dark_1_turquoise,
        shade_dark_2: brandingColors.dark_2_turquoise,
        shade_dark_3: brandingColors.dark_3_turquoise
      }
    },
    utilityColors: {
      error: brandingColors.red_error,
      alert: brandingColors.red_error,
      warning: brandingColors.gold,
      info: brandingColors.light_2_blue,
      complete: brandingColors.m_green
    }
  },
  dropdown: {
    native: false
  },
  footer: {
    logo: {
      height: '20px',
      maxWidth: '100%'
    }
  },
  quickActionNotification: {
    fontSize: rem(14),
    lineHeight: rem(20),
    showDefaultIcon: false,
    // NOTE: This format is intended to map 1:1 with our useMedia hook
    media: {
      queries: ["(max-width: ".concat(GRID_BREAKPOINTS_CONNECTED.MOBILE, "px)")],
      values: [{
        offsetBottom: '16px',
        offsetHorizontal: '16px',
        maxWidth: 'none',
        fullWidth: true
      }],
      defaultValue: {
        offsetBottom: '32px',
        offsetHorizontal: '32px',
        maxWidth: '320px',
        fullWidth: false
      }
    },
    colors: {
      default: brandingColors.dark_navy,
      error: '#A00E18',
      success: brandingColors.dark_1_green
    }
  },
  sideNav: {
    brandLogo: {
      showLogo: true,
      height: '80px',
      width: '80px'
    },
    wordmarkLogo: {
      height: '20px',
      maxWidth: '100%'
    },
    mainNav: {
      top: '0px',
      backgroundColor: brandingColors.light_1_dark_navy,
      fontSize: rem(13),
      lineHeight: 'normal',
      iconOpacity: 0.4
    },
    subNav: {
      item: {
        height: '80px',
        padding: '60px',
        selected: {
          backgroundColor: brandingColors.light_2_grey,
          borderColor: brandingColors.m_green,
          fontWeight: 400
        }
      }
    },
    mobile: {
      variant: MOBILE_MENU_VARIANT.OVERLAY,
      color: brandingColors.dark_navy,
      backgroundColor: brandingColors.light_2_grey,
      toggle: {
        showLabel: false
      },
      item: {
        backgroundColor: brandingColors.white,
        height: '80px'
      },
      wordmarkLogo: {
        height: '20px',
        maxWidth: '100%',
        paddingLeft: '18px',
        paddingRight: '18px'
      },
      header: {
        borderColor: brandingColors.light_grey,
        showTabs: false
      },
      footer: {
        borderColor: brandingColors.light_grey,
        showTabs: true
      },
      tab: {
        variant: TAB_VARIANT.NO_LINE
      },
      lang: {
        variant: LANG_VARIANT.SMALL
      },
      searchField: {
        height: '60px'
      },
      signIn: {
        variant: SIGN_IN_VARIANT.OUTLINE
      }
    }
  },
  utilityHeader: {
    showLogo: true,
    height: '80px',
    marginLeft: '0px',
    paddingRight: '28px',
    main: {
      backgroundColor: brandingColors.dark_navy,
      color: brandingColors.white
    },
    sub: {
      backgroundColor: brandingColors.light_2_grey,
      color: brandingColors.dark_navy
    },
    tab: {
      alignment: TAB_ALIGNMENT.RIGHT
    },
    headerButton: {
      height: '44px',
      borderWidth: '0px'
    },
    menu: {
      active: {
        backgroundColor: brandingColors.light_2_grey
      },
      direction: 'bottom left'
    }
  },
  gridConfig: {
    default: {
      columns: 12,
      gutterWidth: 24,
      margin: 64
    },
    breakpoints: [{
      breakpoint: GRID_BREAKPOINTS_CONNECTED.MOBILE,
      columns: 12,
      gutterWidth: 16,
      margin: 16
    }, {
      breakpoint: GRID_BREAKPOINTS_CONNECTED.TABLET,
      columns: 12,
      gutterWidth: 24,
      margin: 40
    }, {
      breakpoint: GRID_BREAKPOINTS_CONNECTED.TABLET_DESKTOP,
      columns: 12,
      gutterWidth: 24,
      margin: 40
    }, {
      breakpoint: GRID_BREAKPOINTS_CONNECTED.DESKTOP,
      columns: 12,
      gutterWidth: 24,
      margin: 40
    }]
  }
};
var globalTheme$1 = globalTheme;

export { globalTheme$1 as default };
